import { __ } from "@wordpress/i18n";

import QueryPanel from "./QueryPanel";
import LayoutPanel from "./LayoutPanel";
import SliderPanel from "../../../_shared/loop-slider-panel";

export default function PostsInspectorControls({ attributes, setAttributes }) {
  const { query = {}, displayLayout = {}, slider = {} } = attributes;

  const updateQuery = (next) => setAttributes({ query: { ...query, ...next } });
  const updateLayout = (next) =>
    setAttributes({ displayLayout: { ...displayLayout, ...next } });
  const updateSlider = (next) =>
    setAttributes({ slider: { ...slider, ...next } });

  return (
    <>
      <QueryPanel query={query} updateQuery={updateQuery} />
      <LayoutPanel
        displayLayout={displayLayout}
        updateLayout={updateLayout}
        isSlider={!!slider.enabled}
      />
      <SliderPanel
        slider={slider}
        updateSlider={updateSlider}
        templateLabel={__("Post Template", "brandy-blocks")}
        itemLabel={__("featured image", "brandy-blocks")}
      />
    </>
  );
}
